module.exports = __webpack_public_path__ + "img/QC_webpage.4ca89d1b.png";